import { Directive } from "@angular/core";
import { ToggleControlComponent } from "./toggle-control.component";

@Directive({
    selector: "[common-toggle-none-control]",
})
export class NoneControlDirective {
    constructor(private toggleControl: ToggleControlComponent) {
        this.toggleControl.toggleLabel = "None";
    }
}
